import './fonts.css';
export const fontsTheme = {
    lineHeight: '1.5',
    article: '1.2rem',
    subArticle: '0.9rem',
    title: '2.2rem',
    titleMax: '4rem',
    subTitle: '1.6rem',
    buttonTextSize: '1rem',
    note: '0.8rem',
    fontFamily: "'Roboto', sans-serif"
};
export const mobileFontsTheme = {
    lineHeight: '1.2',
    article: '1.3rem',
    subArticle: '1.1rem',
    title: '2.2rem',
    titleMax: '4rem',
    subTitle: '1.6rem',
    buttonTextSize: '1rem',
    note: '1.1rem',
    fontFamily: "'Roboto', sans-serif"
};
export const bordersTheme = {
    borderRadius: '30px',
    inputsBorderRadius: '15px',
    buttonBorderRadius: '50px',
    borderCurrentColor: '1px solid currentColor'
};
export const boxesTheme = {
    progresBackground: '#dcdcdc',
    boxShadow: '1px 1px 2px 1px rgba(0,0,0,0.2)',
    navShadow: '0px 2px 10px 0px rgba(0,0,0,0.2)',
    boxShadowTransition: '4px 4px 6px 6px rgba(0,0,0,0.1)',
    boxShadowInput: '0px 0px 2px 0px'
};
export const paddingsMarginsTheme = {
    themePadding: '1.2rem 1.2rem 1.2rem 1.2rem',
    themePaddingLarge: '1.8rem 1.8rem 1.8rem 1.8rem',
    themeMenuPadding: '0.5rem 0.5rem 0.5rem 0.5rem',
    themeMargin: '0.8rem 0.8rem 0.8rem 0.8rem',
    themeMenuMargin: '0.4rem 0.4rem 0.4rem 0.4rem',
    themeMenuNegativeMargin: '-0.4rem -0.4rem -0.4rem -0.4rem',
    inputsPadding: '0.5rem',
    minPadding: '0.2rem',
    themePaddingSingle: '1.2rem 1.2rem 1.2rem 1.2rem'.split(' ')[0],
    themeMenuPaddingSingle: '0.5rem 0.5rem 0.5rem 0.5rem'.split(' ')[0],
    themePaddingLargeSingle: '1.8rem 1.8rem 1.8rem 1.8rem'.split(' ')[0],
    themeMinPaddingSingle: '0.5rem 0.5rem 0.5rem 0.5rem'.split(' ')[0],
    themeMarginSingle: '0.8rem 0.8rem 0.8rem 0.8rem'.split(' ')[0],
    themeMenuMarginSingle: '0.4rem 0.4rem 0.4rem 0.4rem'.split(' ')[0]
};
export const spacingsTheme = {
    standardSpacing: '2rem',
    halfSpacing: '1rem',
    doubleSpacing: '4rem'
};
export const colorsTheme = {
    mainColor: '#001489',
    mainDark: '#000F6B',
    mainLight: '#789DC1',
    mainLightPlaceholder: '#0059d6',
    secondaryColor: '#EB3300',
    secondaryLight: '#D89261',
    secondaryDark: '#EB3300',
    secondaryLightPlaceholder: '#f07d38',
    errorColor: '#EB1466',
    doneColor: '#33AB63',
    placeholderColor: '#808080',
    darkColor: '#616161',
    greyColor: '#E0E0E0'
};
export const defaultUserTheme = {
    colors: colorsTheme,
    fonts: fontsTheme,
    paddingsMargins: paddingsMarginsTheme,
    spacings: spacingsTheme,
    borders: bordersTheme,
    boxes: boxesTheme,
    logo: ''
};
